import { message } from 'antd';
import { EditingTaskJson } from 'common/types';
import { validateChildTask } from './validateJSON';
//  父子任务、模版涉及暂存相关方法
//  本地暂存区的状态变化
// 返回状态决定当前累计修改发起的update、delete请求
//  add + update = add
//  add + delete = null
export const changeStatus = (preStatus, action) => {
  if (!action) {
    return preStatus;
  }
  if (!preStatus && action) {
    return action;
  }
  switch (action) {
    case 'new':
      return 'new';
    case 'edited':
      return preStatus === 'new' ? 'new' : 'edited';
    case 'deleted':
      return preStatus === 'new' ? 'null' : 'deleted';
  }
  return 'null';
};

export const getStatusTip = status => {
  switch (status) {
    case 'new':
      return '新增';
    case 'edited':
      return '更新';
  }
};

export const filterExistingStages = (taskChildren: EditingTaskJson[]): EditingTaskJson[] => {
  return taskChildren?.filter?.(task => !['null', 'deleted'].includes(task?.status!)) || [];
};

export const findExistingStageById = (taskChildren: EditingTaskJson[], id) => {
  const existingStages = filterExistingStages(taskChildren);
  return existingStages.find(stage => stage.id === id) || {};
};

export const updateStagesInStash = (taskChildren: EditingTaskJson[], stageId, update): EditingTaskJson[] => {
  return (
    taskChildren?.map(task => {
      const { stage, status, id } = task;
      if (id === stageId) {
        const changedStatus = update?.status;
        const newStatus = changeStatus(status, changedStatus);
        return { ...task, ...update, status: newStatus };
      } else {
        return task;
      }
    }) || []
  );
};

export const addStageInStash = (
  taskChildren,
  update,
): { newTaskChild: EditingTaskJson; newTaskChildren: EditingTaskJson[] } => {
  const newTaskChild = {
    ...update,
    status: changeStatus('', 'new'),
    isChosen: true,
    tabsDataSource: [],
    id: Math.floor(Math.random() * (10000 + 1)),
  };
  const newTaskChildren = (taskChildren || []).concat(newTaskChild);
  return { newTaskChild, newTaskChildren };
};

export const deleteStageInStash = (taskChildren, stageId) => {
  let activeIndex;
  const newTaskChildren = taskChildren.map((task, index) => {
    const { stage, status, id } = task;
    if (id === stageId) {
      return { ...task, status: changeStatus(status, 'deleted') };
    } else {
      activeIndex = index;
      return task;
    }
  });
  return { activeIndex, newTaskChildren };
};

export const updateStagesTemplateSortList = (stagesTemplateSortList, preStageId, id): number[] => {
  return stagesTemplateSortList?.map(stageId => (stageId === preStageId ? id : stageId)) || [];
};

export const getStagesTemplateSortList = (taskChildren: EditingTaskJson[]) => {
  const stageTemplateSortList = filterExistingStages(taskChildren)?.map?.(({ id }) => id) || [];
  return stageTemplateSortList;
};

export const validateTaskJson = (taskChildren: EditingTaskJson[]) => {
  const existingStages = filterExistingStages(taskChildren);
  if (!existingStages?.length) {
    message.error('阶段为空');
    return false;
  }
  const isRulesReady = existingStages?.every?.(({ template, stage }) => {
    if (!template?.length) {
      message.error(`【${stage}】阶段的文件类型为空`);
      return false;
    }
    return true;
  });
  if (!isRulesReady) {
    return false;
  }
  const isFormError = taskChildren?.some(({ tabsSource }) => tabsSource && validateChildTask(tabsSource));
  if (isFormError) {
    message.error(`有错误的配置项，请检查！`);
    return false;
  }
  return true;
};
